/**
 * @author jiangtao
 * @description control抽离过程中 涉及到的control处理
 */

import equal from 'fast-deep-equal'
import stringify from 'safe-json-stringify'
import getId from './randomId'
import copy from 'fast-copy'


export const treeListToMap = (treeList = [], debug) => {
  const controls = {};
  const convertControl = (control, parentCtrl) => {
    control.parentId = parentCtrl ? parentCtrl.controlId : '';
    control.parent = parentCtrl
    control.id = control.controlId;
    if (Array.isArray(control.children)) {
      control.childrenIds = control.children.map(ctrl => convertControl(ctrl, control));
    }
    controls[control.controlId] = control;
    return control.controlId;
  };

  return {
    childrenIds: treeList.map(ctrl => convertControl(ctrl)),
    controls,
  };
}

export const filterReplacerIncludeChildren = (k, v) => {
  const defaultBlackList = [
    'isOpened', 'active', 'map', 'define', 'parent', 'style', 'props'
  ]
  return v
}


export const isElder = (srcId, destId, maps) => {
  console.log(maps)
  // vuex 中的parent字段存的是有问题的， 用parentId带她
  if (srcId === destId) return false
  let parentId = maps[destId] && maps[destId].parentId
  while (parentId && parentId.length) {
    // // console.log(srcId, parentId)
    if (parentId === srcId) return true
    parentId = maps[parentId] && maps[parentId].parentId
  }
  return false
}

let checker = {}
export const mapToTreeList = (childrenIds, controlsMap) => {
  let controls = []
  var dfs = (children, root) => {
    children.forEach(id => {
      let item = controlsMap[id]
      if (item) {
        item.parent = controlsMap[item.parentId] || null
        item.children = []
        if (item.childrenIds && item.childrenIds.length) {
          dfs(item.childrenIds, item.children)
        }
        root.push(item)
        if (!checker[id]) {

          checker[id] = 1
        } else {
          // console.log('dulplicate id', Object.keys(checker), root)
        }
      }
    })
  }
  dfs(childrenIds, controls)
  return {
    controlsMap,
    controlList: controls
  }
}

export const getMiniControls = (controls) => {
  return JSON.parse(stringify(controls, filterReplacerIncludeChildren))
}

export const getCleanControl = (control, isRecurse = true) => {
  return getFilteredControl(control, undefined, isRecurse)
}
export const getCleanControlWithChildren = (control) => {
  return getFilteredControl(control, [
    'isOpened', 'active', 'map', 'define'
  ])
}
export const getCleanMiniControl = control => {
  return getFilteredControl(control, [
    'isOpened', 'active', 'map', 'define', 'styles', 'options'
  ])
}

const copyControl = (control, hasChildren) => {
  if (hasChildren) return copy(control);
  const newControl = Object.assign({}, control);
  delete newControl.children;
  delete newControl.parent;
  return copy(newControl);
}

export const getFilteredControl = (
  control,
  filterKeys = ['isOpened', 'active', 'map', 'define', 'parent', 'children'],
  isRecurse = true
) => {
  const o = copyControl(control, isRecurse);
  const filter = obj => {
    filterKeys.forEach(k => delete obj[k])
    return obj
  }
  if (isRecurse && Array.isArray(o.children)) {
    o.children = o.children.map(ctrl => getFilteredControl(ctrl, filterKeys))
  }
  return filter(o)
}

/**
 * @description 处理两个control对比
 * @param {*} origin
 * @param {*} src
 *
 * fix: Converting circular structure to JSON
 * reference: https://stackoverflow.com/questions/11616630/json-stringify-avoid-typeerror-converting-circular-structure-to-json/11616993
 */
export const diffControl = (origin = [], src = [], modifiedControls) => {
  const originMap = treeListToMap(origin, 'src').controls
  const srcMap = treeListToMap(src, 'src').controls
  const start = Date.now()

  const cache = {}
  const allIds = []
  Object.keys(srcMap).concat(Object.keys(originMap)).forEach((id) => {
    if (!cache[id]) {
      allIds.push(id)
      cache[id] = 1
    }
  })

  let diffControls = allIds.reduce((last, id) => {
    let originSource, source
    let s = Date.now()
    // 找出新增的
    if (!originMap[id] && srcMap[id]) {
      source = getCleanControl(srcMap[id])
      // 新增
      last[id] = source
      last[id].operateType = 'add'

      // 找出删除的
    } else if (originMap[id] && !srcMap[id]) {
      originSource = getCleanControl(originMap[id])
      last[id] = originSource
      last[id].operateType = 'delete'
    }
    return last
  }, {})

  Object.keys(modifiedControls).forEach(id => {
    if (!diffControls[id]) {
      diffControls[id] = modifiedControls[id]
    }
  })

  return diffControls
}

export const getChildrenIds = src => {
  return src.map(item => item.id || item.controlId)
}




export const diffChildrenIds = (one, another) => {
  return !equal(one, another)
}
let filterKeys = {
  'active': 1,
  'parent': 1,
  'typeName': 1,
  'define': 1,
  props: {},
  isOpened: 1
}; //过滤字段

function toFilterKeys (filterKeys, target) {
  if (!target)
    return;
  for (const key of Object.keys(filterKeys)) {
    let value = filterKeys[key];
    if (value == 1) {
      delete target[key];
    } else {
      toFilterKeys(value, target[key])
    }
  }
}

export const handleImg = (define, control) => {
  const defaultBucketName = 'hexyun';
  const item = Object.assign({}, control);
  if (item.type !== 'custom') {
    item.style = Object.assign({}, control.style);
  }

  if (item.props)
    item.props = Object.assign({}, control.props);
  if (item.events)
    item.events = Object.assign({}, control.events);

  ['events', 'props', 'dataSource'].map(temp => {
    for (const prop in item[temp]) {
      if (item[temp][prop] == null || item[temp][prop] === '')
        delete item[temp][prop];
    }
  });
  if (item.props) {
    for (const prop of Object.keys(item.props)) {
      //专门处理img类型的prop
      if (define.props[prop] && define.props[prop].type) {
        if (define.props[prop].type === 'img' && define.props[prop].type != 'custom') {
          if (item.props.showType === 1) {
            let values = [];
            if (item.props[prop] && Array.isArray(item.props[prop])) {
              item.props[prop].map(img => {
                values.push({
                  _id: img._id,
                  type: 'img',
                  bucketName: img.bucketName || defaultBucketName,
                })
              });
              if (values.length) item.props[prop] = values;
            }
          } else {
            item.props[prop] = {
              _id: item.props[prop]._id,
              type: 'img',
              bucketName: item.props[prop].bucketName || defaultBucketName,
            }
          }

        } else if (define.props[prop].type === 'arrayImg' && item.props[prop]) {
          let values = [];

          try {
            item.props[prop].map(it => {
              values.push({
                _id: it._id,
                bucketName: it.bucketName || defaultBucketName,
              })
            });
          } catch (e) {

          }

          item.props[prop] = {
            type: 'arrayImg',
            pics: values
          };
        }
      }
    }
  }
  toFilterKeys(filterKeys, item);
  return item
}

function verifyControls (debug, modifieds, controlsMap, childrenIds, msg) {
  if (!debug) return null
  function _getMsg (control, errmsg) {
    return {
      id: control.id,
      childrenIds: control.childrenIds,
      errmsg: errmsg,
      parentId: control.parentId
    }
  }

  // 遍历修改记录
  for (let key in modifieds) {
    const control = modifieds[key];
    for (const childId of (control.childrenIds || [])) {
      // 遍历子控件列表
      const child = modifieds[childId];
      // 如果子控件的父ID != 当前控件ID 不匹配
      if (child && child.parentId != control.id) {
        console.log("not match", control, child);
      }
    }
  }

  // 所有更改的控件IDS
  let keys = Object.keys(modifieds);
  // 新增/修改的控件IDS
  let addOrUpdateControlIds = keys.filter(id => modifieds[id].operateType !== 'delete')

  function fixChildrenIds (control) {
    try {
      // 从 controlsMaps 中寻找原记录
      const origin = controlsMap[id];
      const originChildrenIds = origin.children.map(item => item.id);
      if (origin.childrenIds && originChildrenIds.length >= control.childrenIds.length) {
        control.childrenIds = originChildrenIds;
      }
    } catch (e) { }
  }

  function makeTree () {
    let relation = {}
    for (let id of addOrUpdateControlIds) {
      const parentId = modifieds[id].parentId;
      // 如果有父ID && 父节点被修改
      if (parentId && modifieds[parentId]) {
        // 记录对应关系, 父节点的子节点列表
        if (!relation[parentId]) {
          relation[parentId] = [id]
        } else {
          relation[parentId].push(id)
        }
      }
    }
    // 遍历对应关系
    for (let id in relation) {
      const control = modifieds[id]; // 父节点
      // 必定存在子节点
      if (!control.childrenIds) {
        fixChildrenIds(control);
        continue;
      }
      // 循环被修改的子节点, 判断是否在父节点的 chlidrenIds中
      const modifiedChildrenIds = relation[id];
      for (const childId of modifiedChildrenIds) {
        if (!control.childrenIds.includes(childId)) {
          fixChildrenIds(control);
          break;
        }
      }
    }
    return null;
  }
  return makeTree();
}


function upload (result) {
  let o = new Image()
  o.src = `/api/control/report?data=${JSON.stringify(result)}`
}

/**
 * 验证记录的 modifieds 是否正确
 * @param {*} modifieds 修改记录
 * @param {*} controlsMap 控件Map列表
 * @param {*} childrenIds 根节点控件列表
 * @param {*} msg 消息列表
 * @param {*} stack 操作栈列表
 * @param {*} ui UI操作
 * @param {*} page_id 页面ID
 * @param {*} app_id 应用ID
 */
export const verify = (modifieds, controlsMap, childrenIds, msg, stack, ui, page_id, app_id) => {
  let r = verifyControls(true, modifieds, controlsMap, childrenIds, msg)
  if (r) {
    let result = {
      ...r,
      stack,
      page_id,
      app_id,
      type: 'control.browser'
    }
    upload(result);
    if (typeof ui === 'function') {
      ui(r.errmsg);
    }
    return result;
  }
  return null;
}



// WEBPACK FOOTER //
// ./src/utils/controlDetacher.js